import React from "react";
import AdminSidebar from "../../components/Admin/general/AdminSidebar";
import AdminHeader from "../../components/Admin/general/AdminHeader";

const AdminMasterLayout = ({ children, screenName }) => {
    return (
        <>
            <AdminHeader />
            <AdminSidebar screenName={screenName} />
            <main className="admin-main-content">
                {children}
            </main>
        </>
    );
};

export default AdminMasterLayout;